import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => (
  <header className="App-header">
    <h1 className="App-title">
      <Link className="App-title-link" to='/'>Damian Files</Link>
    </h1>
  </header>
);

export default Header;
